import { InjectionToken } from '@angular/core';

export const BASE_PATH: InjectionToken<string> = new InjectionToken<string>('basePath');
export const PSNB_BASE_PATH: InjectionToken<string> = new InjectionToken<string>('psnbBasePath');
export const COLLECTION_FORMATS = {
    'csv': ',',
    'tsv': '   ',
    'ssv': ' ',
    'pipes': '|'
};
